module.exports = __webpack_public_path__ + "media/components/assets/icons/star_blue_full-1c8b774ca4da4b2abca8e3458eb5c05e.svg";